import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectUser } from "../store/authSlice";

export default function SuperadminGuard({ children }) {
  const user = useSelector(selectUser);
  if (!user || Number(user.role_id) !== 1) {
    return <Navigate to="/" replace />;
  }
  return children;
}
